/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankingfindata": {
        "nested": {
          "transaction": {
            "nested": {
              "AccountUniqueIdentifier": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.bankingfindata.transaction.AccountUniqueIdentifier.AccountSourceType",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AccountSourceType": {
                    "values": {
                      "BALANCE_REPORTER": 1,
                      "FIDELIUS_TOKEN": 2,
                      "PLAID": 3,
                      "BIZBANK": 4,
                      "CORPORATE_CARD": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankingfindata?.nested?.transaction?.nested?.AccountUniqueIdentifier && !$root.nested?.squareup?.nested?.bankingfindata?.nested?.transaction?.nested?.AccountUniqueIdentifier?.nested?.AccountSourceType) {
  $root.addJSON(jsonData);
}

/**
 * @desc The unique identifier for an account
 *
 * SOURCE AccountUniqueIdentifier @ squareup/bankingfindata/transaction.proto at 143:1
 */
export const AccountUniqueIdentifier = $root.lookupType('squareup.bankingfindata.transaction.AccountUniqueIdentifier');
fixType(AccountUniqueIdentifier, {
  id: {
    required: true
  },
  source: {
    required: true
  }
});
Builder.createAndAttachToType(AccountUniqueIdentifier);
/**
 * SOURCE AccountSourceType @ squareup/bankingfindata/transaction.proto at 144:3
 */
AccountUniqueIdentifier.AccountSourceType = $root.lookupEnum('squareup.bankingfindata.transaction.AccountUniqueIdentifier.AccountSourceType').values;